export default __webpack_public_path__ + "static/media/NEW_ZEALAND.7bd571ae.png";